export default __webpack_public_path__ + "static/media/MaskGroup306.9201ee10.png";